import Alert from "./alert";
import classes from "../classes";
import ImportPicksBetList from "../containers/import-picks-bet-list";
import LightBox from "./light-box";
import LightBoxBody from "./light-box-body";
import LightBoxFooter from "./light-box-footer";
import React from "react";
import withState from "./higher-order/with-state";

class ImportPicksLightBox extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onSelectTicket = this.onSelectTicket.bind(this);
    this.onSavePicks = this.onSavePicks.bind(this);
  }

  componentDidUpdate(prevProps) {
    var { communications: prevCommunications } = prevProps;
    var { communications: nextCommunications, setState } = this.props;

    if (prevCommunications.getIn(["tournamentImportPicks", "state"]) === "in progress" && nextCommunications.getIn(["tournamentImportPicks", "state"]) !== "in progress") {
      setState({ showBanner: true });
    }
  }

  onSelectTicket(e) {
    var { setState } = this.props;
    setState({ selectedTicket: e.target.value });
  }

  onSavePicks() {
    var {
      selectedTicket,
      ticket,
      tournament,
      tournamentImportPicks,
    } = this.props;

    tournamentImportPicks(selectedTicket, ticket.get("id"), tournament.get("id"));
  }

  render() {
    var {
      communications,
      onClose,
      selectedTicket,
      showBanner,
      ticket,
      ticketsForRacesInCurrentTournament,
      tournament,
      tournaments
    } = this.props;

    var alertBox;

    var errorMessage = communications.getIn(["tournamentImportPicks", "error"]);
    var successMessage = communications.getIn(["tournamentImportPicks", "state"]) === "success";

    if (showBanner) {
      if (errorMessage) {
        alertBox = (<Alert icon="dw-blocked" title={errorMessage} type="notification--error" />);
      } else if (successMessage) {
        alertBox = (<Alert icon="dw-checkmark" title="Picks imported successfully" type="notification--success" />);
      }
    }

    var sourceGameOptions = ticketsForRacesInCurrentTournament.map(importableTicket => {
      var ticketTournament = tournaments.get(parseInt(importableTicket.get("tournament_id")));
      return (
        <option key={importableTicket.get("id")} value={importableTicket.get("id")}>
          {`${ticketTournament.get("name")} (${importableTicket.get("ticket_number")})`}
        </option>
      );
    });

    var buttonClasses = classes({
      "btn": true,
      "btn--primary": true,
      "btn--is-loading": (communications.getIn(["tournamentImportPicks", "state"]) === "in progress")
    });

    return (
      <LightBox onClose={onClose} title="Import Picks" wide>
        <LightBoxBody>
          {alertBox}

          <div className="batch-g">
            <div className="batch-c-1-1 batch-c-md-11-24">
              <label>
                From this game:
              </label>

              <div className="form_input form_input--select form_input--is-block margin-bottom--is-20-mobile">
                <select className="js-behavior-show-import-table" id="state" name="state" onChange={this.onSelectTicket}>
                  <option value="-1">
                    Select Source Game
                  </option>

                  {sourceGameOptions}
                </select>
              </div>
            </div>

            <div className="batch-c-1-1 batch-c-md-1-12 text-center hidden--mobile">
              <i className="dw-share-alternative dw--r-90 dw--2x color--is-light-gray opacity--is-75 margin-top--is-20" />
            </div>

            <div className="batch-c-1-1 batch-c-md-11-24">
              <label>
                { `Into ticket #${ticket.get("ticket_number")} on this game:`}
              </label>

              <h3 className="margin-top--is-15 margin-bottom--is-0">
                {tournament.get("name")}
              </h3>
            </div>
          </div>

          <div className="batch-g">
            <ImportPicksBetList currentTicket={ticket} ticketId={selectedTicket} tournament={tournament} />

            <div className="batch-c-1-1 batch-c-md-1-12 text-center hidden--mobile" />

            <ImportPicksBetList currentTicket={ticket} ticketId={ticket.get("id")} tournament={tournament} />
          </div>
        </LightBoxBody>

        <LightBoxFooter>
          <button className="btn js-behavior-close-lightbox" onClick={onClose} type="button">
            Close
          </button>

          <button className={buttonClasses} onClick={this.onSavePicks} type="button">
            Save Picks
          </button>
        </LightBoxFooter>
      </LightBox>
    );
  }

}

export default withState(ImportPicksLightBox);

